import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useNavigate, useLocation } from 'react-router-dom';
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper } from '@mui/material';
import { RingLoader } from 'react-spinners';
import { FormaDateBalanceSheet } from "../../../Common/FormatFunctions/FormatDate";

const apikey = process.env.REACT_APP_API;

const SaleTDSPartyWiseRegister = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // const { fromDate, toDate } = location.state || { fromDate: '', toDate: '' ,companyCode : '',Year_Code : ''};
    const searchParams = new URLSearchParams(location.search);
    const fromDate = searchParams.get('fromDate');
    const toDate = searchParams.get('toDate');
    const company_Code = searchParams.get('companyCode');
    const YearCode = searchParams.get('yearCode');
    const acCode = searchParams.get('acCode');
    const Company_Name = sessionStorage.getItem('Company_Name')
    const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [emailId, setEmailId] = useState('');

    const [grandTotals, setGrandTotals] = useState({
        TotalTaxable_Amt: 0,
        CGSTAmt: 0,
        SGSTAmt: 0,
        IGSTAmt: 0,
        BillamountAmt: 0,
        TDSAmt: 0
    });

    const API_URL = `${apikey}/SaleTDS_Register`;

    useEffect(() => {
        const fetchReportData = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(API_URL, {
                    params: {
                        from_date: fromDate,
                        toDate: toDate,
                        companyCode: company_Code,
                        YearCode: YearCode,
                        acCode: acCode
                    },
                });
                setReportData(response.data);
            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report');
            } finally {
                setLoading(false);
            }
        };

        fetchReportData();
    }, [API_URL]);

    const handleExportToExcel = () => {
        const wb = XLSX.utils.book_new();
        const headers = [
            "PAN", "Party Name", "Taxable Amount", "CGST", "SGST", "IGST", "Bill Amount", "TDS Amount"
        ];
        const formattedData = reportData.map(item => ({
            PAN: item.Pan,
            "Party Name": item.Name_Of_Party,
            "Taxable Amount": Number(item.Taxable_Amt) || 0,
            "CGST": Number(item.CGST) || 0,
            "SGST": Number(item.SGST) || 0,
            "IGST": Number(item.IGST) || 0,
            "Bill Amount": Number(item.Bill_Amount) || 0,
            "TDS Amount": Number(item.TDS_Amt) || 0
        }));
        const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });
        const wsCols = [
            { wch: 15 },
            { wch: 30 },
            { wch: 15, alignment: { horizontal: "right" } },
            { wch: 10, alignment: { horizontal: "right" } },
            { wch: 10, alignment: { horizontal: "right" } },
            { wch: 10, alignment: { horizontal: "right" } },
            { wch: 15, alignment: { horizontal: "right" } },
            { wch: 12, alignment: { horizontal: "right" } }
        ];
        ws["!cols"] = wsCols;
        XLSX.utils.book_append_sheet(wb, ws, 'SaleTDSRegister');
        XLSX.writeFile(wb, 'SaleTDSRegister.xlsx');
    };

    const handleSendEmail = async () => {
        if (!emailId) {
            setError('Please enter an email address');
            return;
        }

        const pdfBlob = await generatePDF();
        const pdfFileToSend = new File([pdfBlob], 'report.pdf');

        const formData = new FormData();
        formData.append('email', emailId);
        formData.append('pdf', pdfFileToSend);

        try {
            const response = await axios.post(`${apikey}/send-pdf-email`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            alert(response.data.message || 'Email sent successfully');
        } catch (error) {
            console.error('Error sending email:', error);
            setError('Failed to send email');
        }
    };

    const handlePrint = async () => {
        try {
            const companyName = Company_Name;
            const fromDate = searchParams.get('fromDate');
            const toDate = searchParams.get('toDate');

            if (!reportData || reportData.length === 0) {
                console.error("Error: reportData is empty or undefined");
                return;
            }

            const pdfBlob = await generatePDF(companyName, fromDate, toDate, reportData);

            if (!pdfBlob || !(pdfBlob instanceof Blob)) {
                console.error("Error: Invalid PDF Blob", pdfBlob);
                return;
            }

            const pdfUrl = URL.createObjectURL(pdfBlob);
            const win = window.open(pdfUrl);

            if (!win) {
                console.error("Popup blocked! Allow popups to print the PDF.");
                return;
            }

            setTimeout(() => win.print(), 1000);
        } catch (error) {
            console.error("Error in handlePrint:", error);
        }
    };


    const generatePDF = async (companyName, fromDate, toDate, reportData) => {
        const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });

        // Header
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(companyName || "Company Name", 105, 15, { align: "center" });

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text(`GSTN : ${Company_GSTNO || ""}`, 105, 22, { align: "center" });

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text("Sale TDS Summary Party Wise", 105, 30, { align: "center" });

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text(`${FormaDateBalanceSheet(fromDate)} to ${FormaDateBalanceSheet(toDate)}`, 105, 37, { align: "center" });

        const groupedData = groupReportData(reportData);
        let currentY = 45;

        let grandTotals = {
            TotalTaxable_Amt: 0,
            CGSTAmt: 0,
            SGSTAmt: 0,
            IGSTAmt: 0,
            BillamountAmt: 0,
            TDSAmt: 0,
        };

        for (const [key, group] of Object.entries(groupedData)) {
            if (!group.items || group.items.length === 0) continue;

            const parts = key.split("-");
            const pan = parts[parts.length - 1];
            const partyName = parts.slice(1, -1).join("-");

            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.text(`PAN: ${pan}`, 10, currentY);
            doc.text(`Party: ${partyName}`, 60, currentY);
            currentY += 6;

            const bodyRows = group.items.map(item => [
                item.InvoiceNo || "",
                item.Inv_date || "",
                formatReadableAmount(item.Taxable_Amt),
                formatReadableAmount(item.CGST),
                formatReadableAmount(item.SGST),
                formatReadableAmount(item.IGST),
                formatReadableAmount(item.Bill_Amount),
                formatReadableAmount(item.TDS_Amt),
            ]);

            // Append subtotal row
            bodyRows.push([
                'Sub Total',
                '',
                formatReadableAmount(group.TotalTaxable_Amt),
                formatReadableAmount(group.CGSTAmt),
                formatReadableAmount(group.SGSTAmt),
                formatReadableAmount(group.IGSTAmt),
                formatReadableAmount(group.BillamountAmt),
                formatReadableAmount(group.TDSAmt),
            ]);

            doc.autoTable({
                head: [[
                    "Inv No",
                    "Date",
                    "Taxable Amt",
                    "CGST",
                    "SGST",
                    "IGST",
                    "Bill Amt",
                    "TDS Amt"
                ]],
                body: bodyRows,
                startY: currentY,
                theme: "grid",
                margin: { left: 5, right: 5 },
                styles: { fontSize: 8 },
                columnStyles: {
                    0: { cellWidth: 15 },
                    1: { cellWidth: 20 },
                    2: { cellWidth: 25, halign: "right" },
                    3: { cellWidth: 20, halign: "right" },
                    4: { cellWidth: 20, halign: "right" },
                    5: { cellWidth: 20, halign: "right" },
                    6: { cellWidth: 25, halign: "right" },
                    7: { cellWidth: 25, halign: "right" }
                },
                headStyles: {
                    fillColor: [0, 0, 0],
                    textColor: [255, 255, 255],
                    fontStyle: "bold"
                },
                didDrawPage: data => {
                    currentY = data.cursor.y + 10;
                }
            });

            grandTotals.TotalTaxable_Amt += group.TotalTaxable_Amt;
            grandTotals.CGSTAmt += group.CGSTAmt;
            grandTotals.SGSTAmt += group.SGSTAmt;
            grandTotals.IGSTAmt += group.IGSTAmt;
            grandTotals.BillamountAmt += group.BillamountAmt;
            grandTotals.TDSAmt += group.TDSAmt;
        }

        // Grand Total
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Grand Total:", 10, currentY);

        doc.autoTable({
            head: [[]],
            body: [[
                '',
                '',
                formatReadableAmount(grandTotals.TotalTaxable_Amt),
                formatReadableAmount(grandTotals.CGSTAmt),
                formatReadableAmount(grandTotals.SGSTAmt),
                formatReadableAmount(grandTotals.IGSTAmt),
                formatReadableAmount(grandTotals.BillamountAmt),
                formatReadableAmount(grandTotals.TDSAmt)
            ]],
            startY: currentY + 5,
            theme: "grid",
            margin: { left: 5, right: 5 },
            styles: { fontSize: 8 },
            columnStyles: {
                0: { cellWidth: 15 },
                1: { cellWidth: 20 },
                2: { cellWidth: 25, halign: "right" },
                3: { cellWidth: 20, halign: "right" },
                4: { cellWidth: 20, halign: "right" },
                5: { cellWidth: 20, halign: "right" },
                6: { cellWidth: 25, halign: "right" },
                7: { cellWidth: 25, halign: "right" }
            },
            margin: { left: 5, right: 5 }
        });

        return doc.output("blob");
    };

    const groupReportData = (data) => {
        const groupedData = {};
        data.forEach((item) => {
            const key = `${item.Party_Code}-${item.Name_Of_Party}-${item.Pan}`;
            if (!groupedData[key]) {
                groupedData[key] = {
                    items: [],
                    TotalTaxable_Amt: 0,
                    CGSTAmt: 0,
                    SGSTAmt: 0,
                    IGSTAmt: 0,
                    BillamountAmt: 0,
                    TDSAmt: 0,
                };
            }
            groupedData[key].items.push(item);
            groupedData[key].TotalTaxable_Amt += parseFloat(item.Taxable_Amt) || 0;
            groupedData[key].CGSTAmt += parseFloat(item.CGST) || 0;
            groupedData[key].SGSTAmt += parseFloat(item.SGST) || 0;
            groupedData[key].IGSTAmt += parseFloat(item.IGST) || 0;
            groupedData[key].BillamountAmt += parseFloat(item.Bill_Amount) || 0;
            groupedData[key].TDSAmt += parseFloat(item.TDS_Amt) || 0;
        });
        return groupedData;
    };

    const groupedReportData = groupReportData(reportData);

    useEffect(() => {
        const totals = Object.values(groupedReportData).reduce(
            (totals, { TotalTaxable_Amt, CGSTAmt, SGSTAmt, IGSTAmt, BillamountAmt, TDSAmt }) => {
                totals.TotalTaxable_Amt += TotalTaxable_Amt || 0;
                totals.CGSTAmt += CGSTAmt || 0;
                totals.SGSTAmt += SGSTAmt || 0;
                totals.IGSTAmt += IGSTAmt || 0;
                totals.BillamountAmt += BillamountAmt || 0;
                totals.TDSAmt += TDSAmt || 0;
                return totals;
            },
            { TotalTaxable_Amt: 0, CGSTAmt: 0, SGSTAmt: 0, IGSTAmt: 0, BillamountAmt: 0, TDSAmt: 0 }
        );
        setGrandTotals(totals);
    }, [groupedReportData]);
    return (
        <div style={{marginTop:"-80px"}}>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Sale TDS Summary Party Wise</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{FormaDateBalanceSheet(fromDate)} to {FormaDateBalanceSheet(toDate)}</Typography>

            <div className="mb-3 row align-items-center">
                <div className="col-auto">
                    <button className="btn btn-secondary me-2" onClick={handlePrint}>Print</button>
                    <button className="btn btn-success" onClick={handleExportToExcel}>Export to Excel</button>
                </div>
            </div>

            <div style={{ maxHeight: 'calc(100vh - 250px)', overflow: 'auto', border: '1px solid #ccc' }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow style={{ backgroundColor: '#f5f5f5', position: 'sticky', top: 0, zIndex: 2 }}>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>SBill No</TableCell>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold" }}>Inv Date</TableCell>
                            <TableCell style={{ textAlign: "right", fontWeight: "bold" }}>Taxable Amount</TableCell>
                            <TableCell style={{ textAlign: "right", fontWeight: "bold" }}>CGST Amount</TableCell>
                            <TableCell style={{ textAlign: "right", fontWeight: "bold" }}>SGST Amount</TableCell>
                            <TableCell style={{ textAlign: "right", fontWeight: "bold" }}>IGST Amount</TableCell>
                            <TableCell style={{ textAlign: "right", fontWeight: "bold" }}>Bill Amount</TableCell>
                            <TableCell style={{ textAlign: "right", fontWeight: "bold" }}>TDS</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.entries(groupedReportData).map(([key, { items, TotalTaxable_Amt, CGSTAmt, SGSTAmt, IGSTAmt, BillamountAmt, TDSAmt }]) => {
                            const parts = key.split('-');
                            const mc = parts[0];
                            const pan = parts[parts.length - 1];
                            const PartyName = parts.slice(1, -1).join('-');

                            return (
                                <React.Fragment key={key}>
                                    <TableRow >
                                        <TableCell align="center" sx={{ fontWeight: 'bold', color: 'blue' }}>{pan}</TableCell>
                                        <TableCell align="left" sx={{ fontWeight: 'bold', color: 'blue' }}>{PartyName}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(TotalTaxable_Amt.toFixed(2))}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(CGSTAmt.toFixed(2))}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(SGSTAmt.toFixed(2))}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(IGSTAmt.toFixed(2))}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(BillamountAmt.toFixed(2))}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(TDSAmt.toFixed(2))}</TableCell>
                                    </TableRow>

                                    {items.map((item, index) => (
                                        <TableRow key={index} >
                                            <TableCell align="center">{item.InvoiceNo}</TableCell>
                                            <TableCell align="left">{item.Inv_date}</TableCell>
                                            <TableCell align="right">{formatReadableAmount(item.Taxable_Amt)}</TableCell>
                                            <TableCell align="right">{formatReadableAmount(item.CGST)}</TableCell>
                                            <TableCell align="right">{formatReadableAmount(item.SGST)}</TableCell>
                                            <TableCell align="right">{formatReadableAmount(item.IGST)}</TableCell>
                                            <TableCell align="right">{formatReadableAmount(item.Bill_Amount)}</TableCell>
                                            <TableCell align="right">{formatReadableAmount(item.TDS_Amt)}</TableCell>
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            );
                        })}
                    </TableBody>

                    {/* Sticky Footer Row */}
                    <tfoot>
                        <TableRow style={{ position: 'sticky', bottom: 0, backgroundColor: 'yellow', zIndex: 1 }}>
                            <TableCell colSpan={2} sx={{ fontWeight: 'bold', textAlign: 'right' }}>Grand Total</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(grandTotals.TotalTaxable_Amt.toFixed(2))}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(grandTotals.CGSTAmt.toFixed(2))}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(grandTotals.SGSTAmt.toFixed(2))}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(grandTotals.IGSTAmt.toFixed(2))}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(grandTotals.BillamountAmt.toFixed(2))}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(grandTotals.TDSAmt.toFixed(2))}</TableCell>
                        </TableRow>
                    </tfoot>
                </Table>
            </div>

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999
                }}>
                    <RingLoader size={80} />
                </div>
            )}
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default SaleTDSPartyWiseRegister;
